<div class="container-fluid mt-4">

  <div class="d-flex align-items-center justify-content-between mb-3">
    <div>
      <h4 class="mb-1 d-flex align-items-center gap-2">
       <i class="fi fi-rr-form"></i>
        ფორმები
      </h4>
    </div>

    <button class="btn btn-primary"
            (click)="openCreate()"
            [disabled]="!selectedMenuPage">
       ახალი ფორმა
    </button>
  </div>

  <div class="row g-3">
   
    <div class="col-md-4">
      <app-spinner [loading]="loadingPages" text="იტვირთება გვერდები..."></app-spinner>
      <ng-container *ngIf="!loadingPages">
        <div *ngIf="pages?.length; else noPages">

          <div class="form-floating">
            <select class="form-select"
                    id="formPageSelect"
                    [(ngModel)]="selectedMenuPage"
                    (ngModelChange)="onPageChange($event)">
              <option *ngFor="let p of pages" [ngValue]="p.menu_page">
                {{ p.title }}
              </option>
            </select>
            <label for="formPageSelect">აირჩიე ფორმის გვერდი</label>
          </div>

          <!-- <div class="mt-3 p-3 rounded info-box" *ngIf="selectedMenuPage">
            <div class="d-flex align-items-start gap-2">
              <i class="fi fi-rr-info text-primary mt-1"></i>
              <div class="flex-grow-1">
                <div class="fw-semibold">არჩეული გვერდი</div>
                <div class="text-muted small">
                  menu_page: <b>{{ selectedMenuPage }}</b>
                </div>
              </div>
              <span class="badge bg-primary-subtle text-primary">Active</span>
            </div>
          </div> -->

          <!-- <div class="mt-3 d-flex flex-wrap gap-2">
            <span class="badge bg-secondary-subtle text-secondary" *ngIf="pages?.length">
              სულ გვერდები: {{ pages.length }}
            </span>
            <span class="badge bg-success-subtle text-success" *ngIf="selectedMenuPage">
              არჩეული: {{ selectedMenuPage }}
            </span>
          </div> -->

        </div>
        <ng-template #noPages>
          <div class="empty-state">
            <div class="empty-state__icon">
              <i class="fi fi-rr-folder-open"></i>
            </div>
            <div class="fw-semibold">ფორმის ტიპის გვერდები ვერ მოიძებნა</div>
            <div class="text-muted small">
              ჯერ შექმენი მენიუში გვერდი page_type_id=8-ით, შემდეგ აქ გამოჩნდება.
            </div>
          </div>
        </ng-template>
      </ng-container>
    </div>

    <!-- RIGHT: Forms list -->
    <div class="col-12">
      <div class="card shadow border-0">
        <div class="card-header d-flex align-items-center justify-content-between">
          <span class="fw-semibold">მიბმული ფორმები</span>

          <div class="d-flex align-items-center gap-2">
            <!-- <span class="badge bg-light text-dark" *ngIf="selectedMenuPage">
              menu_page: {{ selectedMenuPage }}
            </span> -->
          </div>
        </div>

        <div class="card-body">
          <app-spinner [loading]="loadingForms" text="იტვირთება ფორმები..."></app-spinner>

          <ng-container *ngIf="!loadingForms">
            <div *ngIf="!selectedMenuPage" class="empty-state">
              <div class="empty-state__icon">
                <i class="fi fi-rr-hand-pointer"></i>
              </div>
              <div class="fw-semibold">აირჩიე ფორმის გვერდი</div>
              <div class="text-muted small">მარჯვენა მხარეს გამოჩნდება შესაბამისი ფორმები.</div>
            </div>

            <div *ngIf="selectedMenuPage && !forms?.length" class="empty-state">
              <div class="empty-state__icon">
                <i class="fi fi-rr-add-document"></i>
              </div>
              <div class="fw-semibold">ამ გვერდზე ფორმა ჯერ არ არის</div>
              <div class="text-muted small">
                დააჭირე <b>„ახალი ფორმა“</b>-ს და შექმენი.
              </div>
              <button class="btn btn-outline-primary mt-2" (click)="openCreate()">
                <i class="fi fi-rr-plus me-1"></i> შექმნა
              </button>
            </div>

            <div class="list-group list-group-flush" *ngIf="forms?.length">
              <button type="button"
                      class="list-group-item list-group-item-action py-3"
                      *ngFor="let f of forms"
                      (click)="openEdit(f.id)">
                <div class="d-flex justify-content-between align-items-start gap-3">
                  <div class="flex-grow-1">
                    <div class="d-flex align-items-center gap-2">
                      <span class="fw-semibold">{{ f.title }}</span>
                      <span class="badge"
                            [ngClass]="f.visible == 1 ? 'bg-success-subtle text-success' : 'bg-danger-subtle text-danger'">
                        {{ f.visible == 1 ? 'ჩანს' : 'დამალულია' }}
                      </span>
                    </div>

                    <div class="text-muted small mt-1" *ngIf="f.description">
                      {{ f.description }}
                    </div>

                    <div class="mt-2 d-flex flex-wrap gap-2">
                      <span class="chip">ID: {{ f.id }}</span>
                      <span class="chip">menu_page: {{ f.menu_page }}</span>
                      <span class="chip" *ngIf="f.allow_files == 1">📎 ფაილები: ON</span>
                      <span class="chip" *ngIf="f.allow_files == 0">📎 ფაილები: OFF</span>
                    </div>
                  </div>

                  <div class="text-end d-flex flex-column gap-2">

                    <button class="btn btn-sm btn-outline-primary"
                            (click)="loadSubmissions(f.id); $event.stopPropagation()">
                      <i class="fi fi-rr-envelope me-1"></i>
                      შეტყობინებები
                    </button>
                    
                    <button class="btn btn-sm btn-outline-secondary"
                            (click)="openEdit(f.id); $event.stopPropagation()">
                      <i class="fi fi-rr-pencil me-1"></i> რედაქტირება
                    </button>

                    <button class="btn btn-sm"
                            [ngClass]="f.visible == 1 ? 'btn-outline-warning' : 'btn-outline-success'"
                            (click)="toggleVisible(f.id); $event.stopPropagation()">
                      <i class="fi" [ngClass]="f.visible == 1 ? 'fi-rr-eye-crossed' : 'fi-rr-eye'"></i>
                      {{ f.visible == 1 ? 'დამალვა' : 'ჩართვა' }}
                    </button>

                    <button class="btn btn-sm btn-outline-danger"
                            (click)="deleteForm(f.id); $event.stopPropagation()">
                      <i class="fi fi-rr-trash me-1"></i> წაშლა
                    </button>
                  </div>
                </div>
              </button>
            </div>
          </ng-container>

        </div>
      </div>
    </div>

  </div>



  <div class="card shadow border-0 mt-4" *ngIf="selectedFormId">
  <div class="card-header d-flex align-items-center justify-content-between">
    <span class="fw-semibold">
      ფორმის შეტყობინებები
    </span>

    <span class="badge bg-light text-dark">
      ფორმა ID: {{ selectedFormId }}
    </span>
  </div>

  <div class="card-body">

    <app-spinner
      [loading]="loadingSubmissions"
      text="იტვირთება შეტყობინებები...">
    </app-spinner>

    <ng-container *ngIf="!loadingSubmissions">

      <div *ngIf="!submissions?.length" class="empty-state">
        <div class="empty-state__icon">
          <i class="fi fi-rr-envelope-open"></i>
        </div>
        <div class="fw-semibold">
          შეტყობინებები არ არის
        </div>
      </div>

      <div class="table-responsive" *ngIf="submissions?.length">

        <table class="table align-middle">
          <thead>
            <tr>
              <th>ID</th>
              <th>თარიღი</th>
              <th>სტატუსი</th>
              <th>ქმედებები</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let s of submissions">
              <td>{{ s.id }}</td>
              <td>{{ s.created_at | date:'dd.MM.yyyy HH:mm' }}</td>
              <td>{{ s.status }}</td>
              <td>
                <button class="btn btn-sm btn-outline-secondary" (click)="openSubmission(s.id)">
                  ნახვა
                </button>
              </td>
            </tr>
          </tbody>

        </table>

      </div>

    </ng-container>

  </div>
</div>


</div>









<div class="modal fade show d-block"
     *ngIf="selectedSubmission"
     tabindex="-1"
     style="background: rgba(0,0,0,0.45); z-index: 1080;">
  <div class="modal-dialog modal-lg modal-dialog-scrollable">
    <div class="modal-content border-0 shadow-lg">
      <div class="modal-header">
        <h5 class="modal-title d-flex align-items-center gap-2 mb-0">
          <i class="fi fi-rr-envelope"></i>
          შეტყობინების დეტალები
        </h5>
        <button type="button"
                class="btn-close"
                aria-label="Close"
                (click)="closeSubmissionModal()"></button>
      </div>

      <div class="modal-body" *ngIf="selectedSubmission as s">

        <div class="row g-3 mb-3">
          <div class="col-md-4">
            <div class="small text-muted">ID</div>
            <div class="fw-semibold">{{ s.id }}</div>
          </div>

          <div class="col-md-4">
            <div class="small text-muted">ფორმა</div>
            <div class="fw-semibold">{{ s.form_id }}</div>
          </div>

          <div class="col-md-4">
            <div class="small text-muted">თარიღი</div>
            <div class="fw-semibold">{{ s.created_at | date:'dd.MM.yyyy HH:mm' }}</div>
          </div>
        </div>

        <div class="mb-3" *ngIf="s.status !== undefined && s.status !== null">
          <div class="small text-muted">სტატუსი</div>
          <div class="fw-semibold">{{ s.status }}</div>
        </div>

        <div class="card border-0 bg-light mb-3" *ngIf="s.payload || s.data">
  <div class="card-body">
    <div class="fw-semibold mb-3">შევსებული ველები</div>

    <div *ngFor="let item of (s.payload || s.data) | keyvalue" class="mb-3 pb-3 border-bottom">
      <div class="small text-muted">{{ item.key }}</div>
      <div class="fw-medium" *ngIf="item.value !== null && item.value !== undefined && item.value !== ''">
        {{ item.value }}
      </div>
      <div class="text-muted" *ngIf="item.value === null || item.value === undefined || item.value === ''">
        —
      </div>
    </div>
  </div>
</div>

        <div class="card border-0 bg-light mb-3" *ngIf="!s.payload && (s.payload_json || s.data_json)">
          <div class="card-body">
            <div class="fw-semibold mb-2">მონაცემები</div>
            <pre class="mb-0" style="white-space: pre-wrap; word-break: break-word;">{{ s.payload_json || s.data_json }}</pre>
          </div>
        </div>

        <div class="card border-0 bg-light mb-3" *ngIf="s.files?.length">
          <div class="card-body">
            <div class="fw-semibold mb-3">ფაილები</div>

            <ul class="mb-0 ps-3">
              <li *ngFor="let file of s.files" class="mb-2">
                <a [href]="file.url" target="_blank">
                  {{ file.original_name || file.file_name || ('ფაილი #' + file.id) }}
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div class="row g-3" *ngIf="s.ip || s.user_agent || s.error_text">
          <div class="col-12" *ngIf="s.ip">
            <div class="small text-muted">IP</div>
            <div>{{ s.ip }}</div>
          </div>

          <div class="col-12" *ngIf="s.user_agent">
            <div class="small text-muted">User Agent</div>
            <div style="word-break: break-word;">{{ s.user_agent }}</div>
          </div>

          <div class="col-12" *ngIf="s.error_text">
            <div class="small text-muted">შეცდომა</div>
            <div class="text-danger" style="word-break: break-word;">{{ s.error_text }}</div>
          </div>
        </div>

      </div>

      <div class="modal-footer">
        <button type="button"
                class="btn btn-outline-secondary"
                (click)="closeSubmissionModal()">
          დახურვა
        </button>

        <button type="button"
                class="btn btn-outline-danger"
                *ngIf="selectedSubmission?.id"
                (click)="deleteSubmission(selectedSubmission.id)">
          წაშლა
        </button>
      </div>
    </div>
  </div>
</div>